import React, { useEffect, useState } from 'react';
import { Users, Eye, Wifi } from 'lucide-react';
import api from '../../api/client';

// Phase 87 — "Online ora" widget (Panoramica). Auto-refreshes every 30s.
const REFRESH_MS = 30 * 1000;

const Stat = ({ icon: Icon, label, value, accent, testId }) => (
  <div className="flex items-center gap-3 rounded-lg border border-border bg-background/40 px-4 py-3">
    <div className={`flex h-9 w-9 items-center justify-center rounded-full ${accent}`}>
      <Icon className="h-4.5 w-4.5 h-5 w-5" />
    </div>
    <div>
      <p className="text-xl font-bold leading-none" data-testid={testId}>{value}</p>
      <p className="mt-1 text-[11px] text-muted-foreground">{label}</p>
    </div>
  </div>
);

export const OnlineNowCard = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () => {
      api.get('/admin/online-stats')
        .then(({ data }) => { if (alive) setStats(data); })
        .catch(() => {});
    };
    load();
    const t = setInterval(load, REFRESH_MS);
    return () => { alive = false; clearInterval(t); };
  }, []);

  return (
    <div
      className="rounded-xl border border-[#D4AF37]/30 bg-card p-4"
      style={{ background: 'radial-gradient(ellipse at 0% 0%, rgba(212,175,55,0.08) 0%, rgba(0,0,0,0) 55%)' }}
      data-testid="online-now-card"
    >
      <div className="mb-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="relative flex h-2.5 w-2.5">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-60" />
            <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-emerald-500" />
          </span>
          <h3 className="text-sm font-semibold gold-text" style={{ color: '#D4AF37' }}>Online ora</h3>
        </div>
        <span className="text-[10px] text-muted-foreground">ultimi 5 min · auto-refresh 30s</span>
      </div>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
        <Stat
          icon={Wifi}
          label="Totale online ora"
          value={stats ? stats.total : '—'}
          accent="bg-[#D4AF37]/15 text-[#D4AF37]"
          testId="online-total"
        />
        <Stat
          icon={Users}
          label="Membri loggati"
          value={stats ? stats.members : '—'}
          accent="bg-emerald-500/15 text-emerald-400"
          testId="online-members"
        />
        <Stat
          icon={Eye}
          label="Ospiti anonimi"
          value={stats ? stats.guests : '—'}
          accent="bg-neutral-500/20 text-neutral-300"
          testId="online-guests"
        />
      </div>
    </div>
  );
};

export default OnlineNowCard;
